import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DisplayService } from './display.service';
import { RememberDeviceService } from './remember-device.service';

@Injectable({
  providedIn: 'root'
})
export class MotpService {

  constructor(
    private readonly http: HttpClient,
    private readonly displayService: DisplayService,
    private readonly rdService: RememberDeviceService
  ) { }

  public verifyMobileOtp(otp, credID, credValue, isRegister?: boolean) {
    const postData = { credId: credID, otp: otp, credValue: credValue};
    if (isRegister) {
      postData["userAccessToken"] = true;
    } else {
      postData["deviceTag"] = true;
    }
    this.rdService.checkAndApply(postData);
    return this.http.post(this.displayService.proxyUrl + 'factor/v1/MobileOTPVerifier', postData);
  }
}
